import { Checkbox, Grid, Paper } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import AutoComplete from "../../components/Comman/AutoComplete";
import { ButtonCompo } from "../../components/Comman/Button";
import DynamicFormWithoutSave from "../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../components/withRouter";
import { blackColor, checkboxColor } from "../../config/ColorObj";
import endpoint from "../../config/endpoints";
import {
  beatNotAssignMsg,
  beatSelectMsg,
  noInternetMsg,
  saveFailedMsg,
  savemsg,
  saveWarningMsg,
  serverMsg,
  updateData,
  updateMsg,
} from "../../config/messageconstant";
import { dayWiseBeatDriverJson } from "../../DynamicFormsJson/Transaction/DayWiseBeatDriver";
import { getAreaByTaluka, getAreaByUserType } from "../../Slice/area.slice";
import {
  getBeatBySalesTeamIdAndAreaIdPost,
} from "../../Slice/beat.slice";
import { getDistrictByZone } from "../../Slice/district.slice";
import { getRegionNew } from "../../Slice/region.slice";
import { getDriversByAreaId } from "../../Slice/salesExecutive.slice";
import { getStateByRegion } from "../../Slice/state.slice";
import { getTalukaByDistrict } from "../../Slice/taluka.slice";
import { getVehicleByArea } from "../../Slice/veichleSlice.slice";
import { getZoneByState } from "../../Slice/zone.slice";
import { apiGet, apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
class DayWiseBeatDriverForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DataToSet: [],
      beatAssignList: [],
      salesTeamId: "",
      vehicleId: "",
      adminFlag: false,
      rowData: [],
      formErrors: {},
      dynamicMasterData: {
        regionDetail: this.props.regionList?.region,
        stateDetail: this.props.stateList?.stateByRegion,
        zoneDetail: this.props.zoneList?.zoneByState,
        districtDetail: this.props.districtList?.districtByZone,
        talukaDetail: this.props.talukaList?.talukaByDistrict,
        areaDetail: this.props.areaList?.areaByTaluka,
        areaUserTypeDetail: this.props.areaList?.area,
        salesExecutiveDetail: this.props.salesExecutive.salesExecutive,
      },
      vehicle: "",
      matrixData: [],
      dayList: [
        {
          dayId: 0,
          name: "Monday",
        },
        {
          dayId: 1,
          name: "Tuesday",
        },
        {
          dayId: 2,
          name: "Wednesday",
        },
        {
          dayId: 3,
          name: "Thursday",
        },
        {
          dayId: 4,
          name: "Friday",
        },
        {
          dayId: 5,
          name: "Saturday",
        },
        {
          dayId: 6,
          name: "Sunday",
        },
      ],
    };
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.beatList !== nextProps.beatList) {
      if (this.props.beatList?.beat !== nextProps.beatList?.beat) {
        if (nextProps.beatList?.beat.length != 0) {
          this.setMatrix(nextProps.beatList?.beat);
        }
      }
    }
    if (this.props.regionList !== nextProps.regionList) {
      if (this.props.regionList?.region !== nextProps.regionList?.region) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            regionDetail: nextProps.regionList?.region,
          },
        });
      }
    }
    if (this.props.stateList !== nextProps.stateList) {
      if (
        this.props.stateList?.stateByRegion !==
        nextProps.stateList?.stateByRegion
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stateDetail: nextProps.stateList?.stateByRegion,
          },
        });
      }
    }
    if (this.props.zoneList !== nextProps.zoneList) {
      if (
        this.props.zoneList?.zoneByState !== nextProps.zoneList?.zoneByState
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            zoneDetail: nextProps.zoneList?.zoneByState,
          },
        });
      }
    }
    if (this.props.districtList !== nextProps.districtList) {
      if (
        this.props.districtList?.districtByZone !==
        nextProps.districtList?.districtByZone
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            districtDetail: nextProps.districtList?.districtByZone,
          },
        });
      }
    }
    if (this.props.talukaList !== nextProps.talukaList) {
      if (
        this.props.talukaList?.talukaByDistrict !==
        nextProps.talukaList?.talukaByDistrict
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            talukaDetail: nextProps.talukaList?.talukaByDistrict,
          },
        });
      }
    }
    if (this.props.areaList !== nextProps.areaList) {
      if (
        this.props.areaList?.areaByTaluka !== nextProps.areaList?.areaByTaluka
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaDetail: nextProps.areaList?.areaByTaluka,
          },
        });
      }
    }
    if (this.props.areaList !== nextProps.areaList) {
      if (this.props.areaList?.area !== nextProps.areaList?.area) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaUserTypeDetail: nextProps.areaList?.area,
          },
        });
      }
    }
    if (this.props.salesExecutive !== nextProps.salesExecutive) {
      if (
        this.props.salesExecutive?.salesExecutive !==
        nextProps.salesExecutive?.salesExecutive
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            salesExecutiveDetail: nextProps.salesExecutive?.salesExecutive,
          },
        });
      }
    }
  }




  setMatrix = (beatList) => {

    const { dayList, rowData } = this.state;

    const matList = dayList.map((dayObj) => {
      let matObj = {
        ...dayObj,
      };
      let filterDay = [];

      if (rowData.length != 0) {
        filterDay = rowData.filter(
          (row) => dayObj.dayId == row.day
        );
      }


      const beatListData = beatList.map((beatObj) => {
        let filterBeat = [];
        if (filterDay.length != 0) {
          filterBeat = filterDay[0].vehicleAssignDaywiseDetails.filter(
            (row) => beatObj.beatId == row.beat.id
          );
        }
        let beatDataObj = {
          ...beatObj,
          beatName:
            beatObj.name +
            " ( " +
            beatObj.areaName +
            " - " +
            beatObj.noOfOutlet +
            " )",

          checked: filterBeat.length != 0 ? true : false,
          disabled: false,
        };
        if (filterBeat.length != 0) {
          beatDataObj = {
            ...beatDataObj,
            id: filterBeat[0].id,
          };
        }
        beatDataObj = {
          ...beatDataObj,
        };
        return beatDataObj;
      });
      matObj = {
        ...matObj,
        beatListData: beatListData,
      };
      if (filterDay.length != 0) {
        matObj = {
          ...matObj,
          vehicle: filterDay[0].vehicle.id || "",
          id: filterDay[0].id,
        };
      }
      return matObj;
    });

    this.setState({
      matrixData: matList,
    });
  };

  async componentDidMount() {
    const { getAreaByUserType, getRegionNew, showLoador, showNotification } =
      this.props;
    if (navigator.onLine) {
      const userTypeId = localStorage.getItem("userTypeId");
      if (userTypeId == 1 || userTypeId == 6) {
        this.setState({
          adminFlag: true,
        });

        showLoador({ loador: true });
        getRegionNew().then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      } else {
        showLoador({ loador: true });
        getAreaByUserType().then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }

    if (this.props.params.id) {
      this.getDataById(this.props.params.id);
    }
  }
  getDataById = (dateWiseBitAssignId) => {
    const { showLoador } = this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      const response = apiGet({
        url: endpoint.vehicleAssignDayWiseHeader + "/by-driver?driverId=" + dateWiseBitAssignId,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          if (!data.error) {
            let rowData = data.data;
            this.setState({
              rowData,
              DataToSet: [
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Driver Name",
                  value:
                    rowData[0].driver !== null &&
                      rowData[0].driver.name !== null
                      ? rowData[0].driver.name
                      : "",
                },
              ],
            });
            this.onEditData(rowData);

            return { data: rowData, success };
          }
          return { data: [], success: false };
        }

        return { data: [], success: false };
      });
      return response;
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onCheckBoxClick = (dayId, e) => {
    const { matrixData } = this.state;

    const DataToSet = matrixData.map((matrixDataObj) => {
      if (matrixDataObj.dayId == dayId) {
        let beatListData = matrixDataObj.beatListData.map((beatObj) => {
          return {
            ...beatObj,
            disabled: e.currentTarget.checked,
            checked: false,
          };
        });
        matrixDataObj = {
          ...matrixDataObj,
          beatListData: beatListData,
        };
        return matrixDataObj;
      }
      return matrixDataObj;
    });
    this.setState({
      matrixData: DataToSet,
    });
  };
  onSelectClick = (dayId, beatId, e) => {
    const { matrixData } = this.state;
    const DataToSet = matrixData.map((matrixDataObj) => {
      if (matrixDataObj.dayId == dayId) {
        const beatListData = matrixDataObj.beatListData.map((beatObj) => {
          return {
            ...beatObj,
            checked:
              beatObj.beatId == beatId
                ? e.currentTarget.checked
                : beatObj.checked,
          };
        });
        matrixDataObj = {
          ...matrixDataObj,
          beatListData: beatListData,
        };
        return matrixDataObj;
      }
      return matrixDataObj;
    });
    this.setState({
      matrixData: DataToSet,
    });
  };
  getListById = async (data) => {
    const {
      getStateByRegion,
      getZoneByState,
      getDistrictByZone,
      getTalukaByDistrict,
      getAreaByTaluka,
      getDriversByAreaId,
      showLoador,
      showNotification,
    } = this.props;

    if (navigator.onLine) {
      if (data.region && data.region != "") {
        showLoador({ loador: true });
        await getStateByRegion({ regionIds: data.region }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.state && data.state != "") {
        showLoador({ loador: true });
        await getZoneByState({ stateIds: data.state }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.zone && data.zone != "") {
        showLoador({ loador: true });
        await getDistrictByZone({ zoneIds: data.zone }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.district && data.district != "") {
        showLoador({ loador: true });
        await getTalukaByDistrict({ districtIds: data.district }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.taluka && data.taluka != "") {
        showLoador({ loador: true });
        await getAreaByTaluka({ talukaIds: data.taluka }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.area && data.area != "") {
        showLoador({ loador: true });
        await getDriversByAreaId({ areaId: data.area }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onEditData = async (data) => {
    const { getVehicleByArea, getBeatBySalesTeamIdAndAreaIdPost, showLoador, showNotification } = this.props;

    this.setState({
      salesTeamId: this.props.params.id,
    });

    let areaIdsJson = {
      areaIds: data[0].driver.areaIds.split(","),
    };

    showLoador({ loador: true });
    await getVehicleByArea({ areaId: data[0].driver.areaIds }).then(({ success }) => {
      showLoador({ loador: false });
      if (!success) {
        showNotification({ msg: serverMsg, severity: "error" });
      }
    });

    showLoador({ loador: true });
    await getBeatBySalesTeamIdAndAreaIdPost({
      salesTeamId: this.props.params.id,
      areaIds: areaIdsJson,
    }).then(({ response, success }) => {
      showLoador({ loador: false });
      if (!success) {
        showNotification({ msg: serverMsg, severity: "error" });
      } else {
        if (response.length == 0) {
          this.props.showNotification({
            msg: beatNotAssignMsg,
            severity: "error",
          });
        }
      }
    });
  }

  onSearch = async (data) => {
    const {
      getBeatBySalesTeamIdAndAreaIdPost,
      getVehicleByArea,
      showLoador,
      showNotification,
    } = this.props;

    if (navigator.onLine) {
      this.setState({
        salesTeamId: data.driver.id,
      });


      let areaIdsJson = {
        areaIds:
          typeof data.area === "string" ? data.area.split(",") : data.area,
      };

      showLoador({ loador: true });
      await getVehicleByArea({ areaId: data.area }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });

      showLoador({ loador: true });
      await getBeatBySalesTeamIdAndAreaIdPost({
        salesTeamId: data.driver.id,
        areaIds: areaIdsJson,
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          if (response.length == 0) {
            this.props.showNotification({
              msg: beatNotAssignMsg,
              severity: "error",
            });
          }
        }
      });
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };


  checkValidationNew = (saveToList) => {
    let formErrors = {};
    let formIsValid = true;

    saveToList.map((dataObj) => {
      const key = dataObj.day;
      if (
        dataObj.vehicle.id === undefined ||
        dataObj.vehicle.id === null ||
        dataObj.vehicle.id === ""
      ) {
        formIsValid = false;
        formErrors[key] = "Vehicle Required";
      }
    });

    this.setState({ formErrors });
    return formIsValid;
  };


  onAutocompleteChange = (dayId) => (name, newValue) => {
    const { matrixData } = this.state;

    const updatedMatrixData = matrixData.map((matrixDataObj) => {
      if (matrixDataObj.dayId === dayId) {
        return {
          ...matrixDataObj,
          vehicle: newValue,
        };
      }
      return matrixDataObj;
    });
    this.setState({
      matrixData: updatedMatrixData,
    });
  };

  onSubmit = () => {
    const { matrixData, salesTeamId, } = this.state;
    const { showLoador, showNotification } = this.props;

    let saveToList = [];

    matrixData.map((matrixDataObj) => {
      const beatList = [];

      matrixDataObj.beatListData.map((beatObj) => {
        if (beatObj.checked) {
          beatList.push({
            beat: { id: beatObj.beatId },
          });
        }
      });

      if (beatList.length !== 0) {
        let dayData = {
          driver: { id: salesTeamId },
          day: matrixDataObj.dayId,
          vehicle: { id: matrixDataObj.vehicle },
          vehicleAssignDaywiseDetails: beatList,
        };

        if (this.props.params.id) {
          dayData = {
            ...dayData,
            id: matrixDataObj.id,
          };
        }

        saveToList.push(dayData);
      }
    });

    if (saveToList.length === 0) {
      showNotification({
        msg: beatSelectMsg,
        severity: "error",
      });
      return;
    }


    if (this.checkValidationNew(saveToList)) {

      if (navigator.onLine) {
        swal({
          title: "Are you sure?",
          text: this.props.params.id ? updateData : saveWarningMsg,
          icon: "warning",
          buttons: true,
          dangerMode: true,
        }).then(async (willDelete) => {
          if (willDelete) {
            showLoador({ loador: true });
            await apiPost({
              url: this.props.params.id ?
                endpoint.vehicleAssignDayWiseHeader + "/edit-with-msg?driverId=" + this.props.params.id :
                endpoint.vehicleAssignDayWiseHeader + "/save-list-with-msg",
              postBody: saveToList,
            }).then(({ data, success }) => {
              showLoador({ loador: false });
              if (success) {
                if (data?.data?.error) {
                  showNotification({ msg: data?.data?.message, severity: "error" });
                  return;
                } else {
                  showNotification({
                    msg: this.props.params.id ? updateMsg : savemsg,
                  });
                }
                this.props.navigate(-1);
              } else {
                showNotification({
                  msg: saveFailedMsg,
                  severity: "error",
                });
              }
            }).catch(() => {
              showLoador({ loador: false });
              showNotification({
                msg: serverMsg,
                severity: "error",
              });
            });
          }
        });
      } else {
        showNotification({ msg: noInternetMsg, severity: "error" });
      }
    }

  };



  render() {
    const {
      matrixData,
      dynamicMasterData,
      DataToSet,
      dayList,
      adminFlag,
      vehicleList,
      formErrors,
    } = this.state;
    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 2,
          }}
          elevation={0}
        >
          <DynamicFormWithoutSave
            showBackToList={true}
            DataToSet={DataToSet}
            dynamicMasterData={dynamicMasterData}
            showSaveBtn={dayWiseBeatDriverJson.showSaveBtn}
            showTitle={dayWiseBeatDriverJson.showTitle}
            screenTitle={dayWiseBeatDriverJson.screenTitle}
            fieldMeta={
              this.props.params.id
                ? []
                : adminFlag
                  ? dayWiseBeatDriverJson.fieldMeta
                  : dayWiseBeatDriverJson.fieldMetaForStockHolder
            }
            showCancel={dayWiseBeatDriverJson.showCancel}
            apiBaseURL={dayWiseBeatDriverJson.apiBaseURL}
            showSaveNextBtn={dayWiseBeatDriverJson.showSaveNextBtn}
            saveBtnText={"Search"}
            showSaveBtnMain={this.props.params.id ? false : true}
            getListById={this.getListById}
            onSave={this.onSearch}
          />
          {matrixData.length != 0 && (
            <>
              <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{ width: "5%" }}
                      ></TableCell>
                      <TableCell align="center" sx={{ width: "15%" }}>
                        Vehicle
                      </TableCell>
                      <TableCell align="center" sx={{ width: "5%" }}>
                        Days
                      </TableCell>
                      <TableCell align="center" sx={{ width: "80%" }}>
                        Beats
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {matrixData.map((matrixDataRow, indexRow) => {
                      return (
                        <TableRow>
                          <TableCell>
                            <FormControl component="fieldset">
                              <FormGroup aria-label="position" row>
                                <FormControlLabel
                                  value="end"
                                  control={
                                    <Checkbox
                                      sx={{
                                        color: blackColor,
                                        "&.Mui-checked": {
                                          color: checkboxColor,
                                        },
                                      }}
                                    />
                                  }
                                  label="N/A"
                                  onChange={(e) => {
                                    this.onCheckBoxClick(
                                      matrixDataRow.dayId,
                                      e
                                    );
                                  }}
                                  labelPlacement="end"
                                />
                              </FormGroup>
                            </FormControl>
                          </TableCell>
                          <TableCell>
                            <AutoComplete
                              name="vehicle"
                              label="Vehicle"
                              placeHolder="Select Vehicle"
                              keyColName="id"
                              value={matrixDataRow.vehicle}
                              options={this.props.vehicleList.vehicleByArea}
                              onChange={this.onAutocompleteChange(matrixDataRow.dayId)}
                              errorText={
                                formErrors[matrixDataRow.dayId] ? formErrors[matrixDataRow.dayId] : ""
                              }
                              isError={
                                formErrors[matrixDataRow.dayId] ? true : false
                              }
                            />
                          </TableCell>
                          <TableCell>{matrixDataRow.name}</TableCell>
                          <TableCell>
                            {matrixDataRow.beatListData.map(
                              (columnName, index) => {
                                return (
                                  <FormControl component="fieldset">
                                    <FormGroup aria-label="position" row>
                                      <FormControlLabel
                                        value="end"
                                        control={
                                          <Checkbox
                                            sx={{
                                              color: blackColor,
                                              "&.Mui-checked": {
                                                color: checkboxColor,
                                              },
                                            }}
                                            disabled={columnName.disabled}
                                            checked={columnName.checked}
                                          />
                                        }
                                        label={columnName.beatName}
                                        onChange={(e) => {
                                          this.onSelectClick(
                                            matrixDataRow.dayId,
                                            columnName.beatId,
                                            e
                                          );
                                        }}
                                        labelPlacement="end"
                                      />
                                    </FormGroup>
                                  </FormControl>
                                );
                              }
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
              <br />
              <Grid
                item
                sm={12}
                xs={12}
                md={12}
                lg={12}
                rowSpacing={2}
                columnSpacing={{ xs: 12, sm: 6, md: 1 }}
                container
                justifyContent="right"
              >
                <ButtonCompo
                  size="medium"
                  type="submit"
                  variant="contained"
                  name="Submit"
                  onClick={this.onSubmit}
                />
              </Grid>
            </>
          )}
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  areaList: state.area,
  regionList: state.region,
  stateList: state.states,
  zoneList: state.zone,
  districtList: state.district,
  talukaList: state.taluka,
  beatList: state.beat,
  salesExecutive: state.salesExecutive,
  vehicleList: state.vehicle,
});
const mapDispatchToProps = {
  showLoador,
  showNotification,
  getRegionNew,
  getZoneByState,
  getDistrictByZone,
  getTalukaByDistrict,
  getAreaByTaluka,
  getStateByRegion,
  getAreaByUserType,
  //   getSalesExecutiveByAreaId,
  getDriversByAreaId,
  getBeatBySalesTeamIdAndAreaIdPost,
  getVehicleByArea,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(DayWiseBeatDriverForm);
